import {
  IconInfrastructureBike16,
  IconInfrastructureScooter16,
  IconMapBus16,
  IconMapStreetcar16,
  IconProductCompetitor16,
  IconMapMetroMsk16,
  IconInfrastructureParking16,
} from '@cian/ui-kit-design-tokens/icons';
import { IMapRowsProps } from 'shared/mf-infrastructure/components/MapRows';
import { EOutsideTAInfrastructureType, ITAInfrastructure } from 'shared/mf-infrastructure/types/transportAccessibility';
import { getAvailableOutsideInfrastructureTypes } from 'shared/mf-infrastructure/utils/getAvailableOutsideInfrastructureTypes';

const INFRASTRUCTURE_TYPES: Record<
  EOutsideTAInfrastructureType,
  {
    text: string;
    IconComponent: React.FunctionComponent;
  }
> = {
  [EOutsideTAInfrastructureType.busStops]: {
    text: 'Автобусы',
    IconComponent: IconMapBus16,
  },
  [EOutsideTAInfrastructureType.tramStops]: {
    text: 'Трамваи',
    IconComponent: IconMapStreetcar16,
  },
  [EOutsideTAInfrastructureType.metro]: {
    text: 'Метро',
    IconComponent: IconMapMetroMsk16,
  },
  [EOutsideTAInfrastructureType.parking]: {
    text: 'Парковки',
    IconComponent: IconInfrastructureParking16,
  },
  [EOutsideTAInfrastructureType.bikeParking]: {
    text: 'Велопарковки',
    IconComponent: IconInfrastructureBike16,
  },
  [EOutsideTAInfrastructureType.chargingStations]: {
    text: 'Зарядки электромобилей',
    IconComponent: IconProductCompetitor16,
  },
  [EOutsideTAInfrastructureType.scooterParking]: {
    text: 'Парковка самокатов',
    IconComponent: IconInfrastructureScooter16,
  },
};

export const getOutsideRows = (
  transportAccessibilityInfrastructure: ITAInfrastructure | undefined,
): IMapRowsProps['items'] => {
  const availableInfrastructureTypes = getAvailableOutsideInfrastructureTypes(transportAccessibilityInfrastructure);

  return availableInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPES[type],
  }));
};
